import React from 'react';
import { Link } from 'react-router-dom';

export class Footer extends React.Component {
    constructor(props) {
        super();
        this.state = {
            footerData: {}
        };
    }

    getFooter() {
        fetch(process.env.REACT_APP_API_URL + '/Footer/GetFooter', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*',
                'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
            }
        })
            .then(res => res.json())
            .then((data) => {
                if (data.isSuccess) {
                    this.setState({ footerData: data.footer });
                    this.setState({ footerLinkTexts: JSON.parse(data.footer.link_Texts) });
                    this.setState({ footerLinks: JSON.parse(data.footer.link_Urls) });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    componentDidMount() {
        this.getFooter();
    }

    render() {
        var footerData = this.state.footerData ? this.state.footerData : null;
        var linkTexts = this.state.footerLinkTexts ? this.state.footerLinkTexts : [];
        var links = this.state.footerLinks ? this.state.footerLinks : [];

        return (
            <section id="Footer">
                <div className="container-fluid">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 font-weight-bold mb-md-3">
                                {footerData.title && <h3>{footerData.title}</h3>}
                            </div>
                        </div>
                        <div className="row">

                            <div className="col-md-3">
                                <div>
                                    <p className="footer-title font-weight-bold">Contact us</p>
                                    <div className="paragraphWithoutSpace">
                                        {footerData.contact_Details && <p dangerouslySetInnerHTML={{ __html: footerData.contact_Details }}></p>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 my-md-0 my-4">
                                <div>
                                    <p className="footer-title font-weight-bold">Useful Links</p>
                                    <ul className="list-unstyled footer-list">
                                        {linkTexts.map((data, index) => {
                                            return (
                                                <li key={index}><a href={links[index]} rel="noopener noreferrer" target="_blank" >{data}</a></li>
                                            )
                                        })
                                        }
                                        {/* <li><a href="/" rel="noopener noreferrer">Outward Bound Singapore</a></li>
                                        <li><a href="/" rel="noopener noreferrer">Outward Bound Singapore</a></li>
                                        <li><a href="/" rel="noopener noreferrer">Ministry of Culture Community and Youth</a></li>
                                        <li><a href="/" rel="noopener noreferrer">Ministry of Education</a></li> */}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-3 d-flex justify-content-start justify-content-md-center">
                                <div>
                                    <p className="footer-title font-weight-bolder">Connect with us</p>
                                    <div className="d-flex flex-row">
                                        {footerData.connect1_Url && <div className="pr-3"><a rel="noopener noreferrer" target="_blank" href={footerData.connect1_Url} className="btn btn-link p-0"><img src="images/homepage/Btn_FB.svg" alt="" /></a></div>}
                                        {footerData.connect2_Url && <div className="pr-3"><a rel="noopener noreferrer" target="_blank" href={footerData.connect2_Url} className="btn btn-link p-0"><img src="images/homepage/Btn_Insta.svg" alt="" /></a></div>}
                                        {footerData.connect3_Url && <div className="pr-3"><a rel="noopener noreferrer" target="_blank" href={footerData.connect3_Url} className="btn btn-link p-0"><img src="images/homepage/Btn_Youtube.svg" alt="" /></a></div>}
                                    </div>
                                    {/* <a className="navbar-brand" href="#"><img className="img-fluid" src="images/footer_logo2.png" /></a> */}
                                </div>
                            </div>
                            <div className="col-md-3 my-md-0 my-5 text-md-end text-center">
                                {footerData.partOf_Image && <a href={footerData.partOf_Url} target="_blank" rel="noopener noreferrer"><img alt="logo_footer" className="logo_footer" src={footerData.partOf_Image} /></a>}
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row footer-line-1">
                            <div className="col-md-12 d-flex justify-content-center justify-content-md-end p-0">
                                <ul className="list-unstyled footer-list-2 my-2">
                                    {footerData.contactUs_Link && <li><a href={footerData.contactUs_Link} target="_self">Contact us
                                    {/* <span className="material-icons pl-1 pt-1 align-top">launch</span> */}
                                    </a></li>}
                                    {footerData.feedback_Url && <li><a href={footerData.feedback_Url} target="_self">Feedback<span className="material-icons pl-1 pt-1 align-top">launch</span></a></li>}
                                </ul>
                            </div>
                        </div>
                        <div className="row footer-line-2">
                            <div className="col-md-12 d-md-flex flex-row p-0 mb-2">
                                <div className="line2-content-1 w-100 mb-md-0 mb-3">
                                    <ul className="list-unstyled footer-list-2 my-2 text-center text-md-left">
                                        {footerData.vulnerabilities_Url && <li><a href={footerData.vulnerabilities_Url} target="_blank" rel="noopener noreferrer">Report Vulnerabilities<span className="material-icons pl-1 pt-1 align-top">launch</span></a></li>}
                                        {footerData.privacy_Url && <li><a href={footerData.privacy_Url} target="_self">Privacy</a></li>}
                                        {footerData.term_Url && <li><a href={footerData.term_Url} target="_blank" rel="noopener noreferrer">Term of Use</a></li>}
                                    </ul>
                                </div>
                                <div className="d-flex justify-content-center justify-content-md-end text-center text-md-left mt-2 line2-content-2 w-100">
                                    {footerData.copyright_Title && <p className="m-0">{footerData.copyright_Title}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

